exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-container[data-v-63686a5c]{width:800px;height:400px}.swiper-container .swiper-wrapper[data-v-63686a5c]{width:100%;height:100%}.swiper-container .swiper-slide[data-v-63686a5c]{background-position:50%;background-size:cover;width:100%;height:100%}.swiper-container .swiper-slide img[data-v-63686a5c]{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63686a5c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/components/HelloWorld.vue
// module id = GZtt
// module chunks = 12